import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ActionType } from "~/pages/constants";
import { CreateOrder, TradeToken, PairedToken } from "~/types";
import localStorage from "~/tools/localStorage";

export interface TradeStore {
    order: CreateOrder;
    order_type: number;
    direction: number;

    // 当前的交易代币
    tradeToken: TradeToken;
    // 当前交易代币的对向代币
    pairedToken: PairedToken;
    // 当前的交易类型
    tradeActionType: ActionType | null;
    // 缓存的交易对代币信息
    pairedTokensCache: { [chain_id: string]: PairedToken } | null;
    // 缓存交易模式
    tradeTokenActionTypeCache: {
        [chain_id_contract: string]: ActionType;
    } | null;
}

const initialState: Partial<TradeStore> = {
    pairedTokensCache: {},
    tradeTokenActionTypeCache: {},
};

export const tradeSlice = createSlice({
    name: "trade",
    initialState,
    reducers: {
        updateTradeToken(state, action: PayloadAction<TradeToken>) {
            state.tradeToken = action.payload;
        },
        updatePairedToken(state, action: PayloadAction<PairedToken>) {
            state.pairedToken = action.payload;
        },
        updatePairedTokensCache(
            state,
            action: PayloadAction<{
                [chain_id: string]: PairedToken;
            } | null>
        ) {
            state.pairedTokensCache = action.payload;
        },
        updatePairedTokensCacheForChainId(
            state,
            action: PayloadAction<{ chain_id: string; token: PairedToken }>
        ) {
            const chain_id = action.payload.chain_id;
            const pairedToken = action.payload.token;
            const oldPairedTokens = state.pairedTokensCache ?? {};
            const newPairedTokens = {
                ...oldPairedTokens,
                [chain_id]: pairedToken,
            };

            state.pairedTokensCache = newPairedTokens;
            localStorage.set(
                "__uxuy_dex_cached_paired_tokens__",
                newPairedTokens
            );
        },
        updateTradeActionType(state, action: PayloadAction<ActionType | null>) {
            state.tradeActionType = action.payload;
        },
        updateTradeActionTypeCache(
            state,
            action: PayloadAction<{
                [chain_id_contract: string]: ActionType;
            } | null>
        ) {
            state.tradeTokenActionTypeCache = action.payload;
        },
        updateTradeActionTypeCacheForKey(
            state,
            action: PayloadAction<{
                key: string;
                type: ActionType;
            }>
        ) {
            const oldCache = state.tradeTokenActionTypeCache ?? {};
            const newCache = {
                ...oldCache,
                [action.payload?.key]: action.payload?.type,
            };
            state.tradeTokenActionTypeCache = newCache;
            localStorage.set("__uxuy_dex_cached_action_types__", newCache);
        },
        saveTradeOrder(state, action) {
            state.order = action.payload.order;
            state.order_type = action.payload.order_type;
            state.direction = action.payload.direction;
        },
    },
});

export const {
    updateTradeToken,
    updatePairedToken,
    updatePairedTokensCache,
    updateTradeActionType,
    updateTradeActionTypeCache,
    updatePairedTokensCacheForChainId,
    updateTradeActionTypeCacheForKey,
    saveTradeOrder,
} = tradeSlice.actions;

export default tradeSlice.reducer;
